/*
 * @Author: Dom
 * @Date: 2022-08-08 10:24:49
 * @LastEditTime: 2022-08-16 19:01:41
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\utils\lt18gt65.ts
 */
export function lt18gt65(val: string):boolean{
    console.log('val', val);
    let age=0
    const yearbirth = Number(val.substring(6,10))
    const mothbirth = Number(val.substring(10,12))
    const daybirth = Number(val.substring(12,14))
    const mydate = new Date()
    const monthNow = mydate.getMonth()+1
    const dayNow = mydate.getDate()
    age = mydate.getFullYear() - yearbirth
    if(age<18||age>65){
        return false
    }else if(age===18){
        if(monthNow-mothbirth>0){
            return true
        }else if(monthNow-mothbirth==0&&dayNow>daybirth){
            return true
        }else if(monthNow-mothbirth==0&&dayNow==daybirth){
            return true
        }else{
            return false
        }
    }else if(age===65){
        if(monthNow-mothbirth>0){
            return false
        }else if(monthNow-mothbirth==0&&dayNow<daybirth){
            return true
        }else if(monthNow-mothbirth==0&&dayNow==daybirth){
            return false
        }else{
            return false
        }
    }else{
        return true
    }
}
